import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, Transition as _Transition, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_balloon = _resolveComponent("base-balloon")
  const _component_app_portal = _resolveComponent("app-portal")

  return (_openBlock(), _createBlock(_resolveDynamicComponent($props.tag), {
    ref: "trigger",
    "data-value": _ctx.guid,
    onMouseenter: _withModifiers($options.onMouseOver, ["stop"]),
    onMouseleave: _withModifiers($options.onMouseOut, ["stop"]),
    onClick: $options.onClick,
    "data-qa": "tooltip-trigger"
  }, {
    default: _withCtx(() => [
      ($options.hasIcon)
        ? (_openBlock(), _createBlock(_component_base_icon, {
            key: 0,
            name: $props.iconName
          }, null, 8 /* PROPS */, ["name"]))
        : _createCommentVNode("v-if", true),
      _renderSlot(_ctx.$slots, "default"),
      ($props.enabled)
        ? (_openBlock(), _createBlock(_component_app_portal, {
            key: 1,
            to: "#tooltip"
          }, {
            default: _withCtx(() => [
              _createVNode(_Transition, {
                name: "gfu-tooltip-fade",
                onEnter: $options.onEnter
              }, {
                default: _withCtx(() => [
                  ($options.isVisible)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        ref: "content",
                        tabindex: "0",
                        class: "gfu-tooltip",
                        onClick: _cache[0] || (_cache[0] = (...args) => ($options.closeContentOnClick && $options.closeContentOnClick(...args)))
                      }, [
                        _createVNode(_component_base_balloon, _mergeProps({ class: $options.balloonClasses }, $options.balloonProps, {
                          "data-value": _ctx.guid,
                          "data-qa": "tooltip-text"
                        }), {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($props.text) + " ", 1 /* TEXT */),
                            _renderSlot(_ctx.$slots, "content")
                          ]),
                          _: 3 /* FORWARDED */
                        }, 16 /* FULL_PROPS */, ["class", "data-value"])
                      ], 512 /* NEED_PATCH */))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 3 /* FORWARDED */
              }, 8 /* PROPS */, ["onEnter"])
            ]),
            _: 3 /* FORWARDED */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }, 40 /* PROPS, NEED_HYDRATION */, ["data-value", "onMouseenter", "onMouseleave", "onClick"]))
}